import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { CompanySelectors } from '../../../store/company/selectors'
import { CompanyActions } from '../../../store/company'
import { FlexColumn } from '../../../components/atoms/layout/Flex'
import VisitorRegistrationCompanyForm from '../../../components/organisms/visitor/registration/CompanyForm'

export default function VisitorRegistrationCompanyPage() {
  const dispatch = useDispatch()
  const form = useSelector(CompanySelectors.visitorRegistrationForm)

  useEffect(() => {
    dispatch(CompanyActions.fetchVisitorRegistrationForm())
  }, [dispatch])

  return (
    <FlexColumn>
      <VisitorRegistrationCompanyForm form={form} />
    </FlexColumn>
  )
}
